"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M3.8491 3v15.9585H22V20H2.5V3h1.3491Zm5.2953 4.1456 5.0623 5.8915.9868 1.1483 1.0037-1.1334L20.5 8.1937 22 6.5v12H4.303v-8.3042L7.1378 7.112 8.16 6l.9844 1.1456Zm7.172 8.0343L20.5 10.4561V17H5.803v-6.2195l2.3192-2.523 5.9336 6.9055 1.1206 1.3041 1.14-1.2872Z", clipRule: "evenodd" })), 'AreaGraphIcon');
